import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="site-navbar"
      className="glass sticky top-0 z-40 w-full"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <Link to="/" className="flex items-center" data-testid="nav-logo">
          <img
            src="/nav-wordmark.png"
            alt="RideMate"
            width="1080"
            height="216"
            className="h-8 w-auto object-contain"
            draggable={false}
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={`font-body text-sm tracking-wide transition-colors ${
                pathname === l.to
                  ? "text-[#24303F] font-semibold"
                  : "text-gray-600 hover:text-[#5FA836]"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <a
            href="/#waitlist"
            data-testid="nav-cta-waitlist"
            className="btn-primary rounded-full px-5 py-2 text-sm"
          >
            Join Waitlist
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[#24303F] p-2 -mr-2"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-[#e5e7eb] bg-white px-6 py-5 flex flex-col gap-4"
        >
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              className="font-display text-2xl font-semibold text-[#24303F]"
            >
              {l.label}
            </Link>
          ))}
          <a
            href="/#waitlist"
            onClick={() => setOpen(false)}
            data-testid="mobile-cta-waitlist"
            className="btn-primary rounded-full px-5 py-3 text-sm w-fit"
          >
            Join Waitlist
          </a>
        </div>
      )}
    </header>
  );
}
